import { getCurrentLanguage, setLanguage } from './core/i18n.js';

const SUPPORTED = [
  { code: 'fr', label: 'FR', flag: '/images/flags/fr.svg' },
  { code: 'nl', label: 'NL', flag: '/images/flags/nl.svg' },
  { code: 'en', label: 'EN', flag: '/images/flags/en.svg' },
];

function escapeHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function render(container) {
  const current = getCurrentLanguage();
  const currentLang = SUPPORTED.find(l => l.code === current);
  const currentLabel = currentLang?.label || current.toUpperCase();
  const currentFlag = currentLang?.flag;

  container.innerHTML = `
    <div class="alictron-lang dropdown">
      <button class="solar_btn dropdown-toggle alictron-lang-btn" type="button" aria-expanded="false" aria-label="Language">
        ${currentFlag ? `<img class="alictron-lang-flag" src="${escapeHtml(currentFlag)}" alt="" />` : ''}
        <span class="alictron-lang-label">${escapeHtml(currentLabel)}</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-end alictron-lang-menu">
        ${SUPPORTED.map(({ code, label, flag }) => {
          const active = code === current ? 'active' : '';
          return `
            <li>
              <a class="dropdown-item ${active}" href="#" data-lang="${code}">
                ${flag ? `<img class="alictron-lang-flag" src="${escapeHtml(flag)}" alt="" />` : ''}
                <span class="alictron-lang-label">${escapeHtml(label)}</span>
              </a>
            </li>
          `;
        }).join('')}
      </ul>
    </div>
  `;

  const wrapper = container.querySelector('.alictron-lang');
  const button = container.querySelector('.alictron-lang-btn');
  const menu = container.querySelector('.alictron-lang-menu');

  const setOpen = (open) => {
    if (!button || !menu) return;
    if (open) {
      menu.classList.add('show');
      button.setAttribute('aria-expanded', 'true');
    } else {
      menu.classList.remove('show');
      button.setAttribute('aria-expanded', 'false');
    }
  };

  if (wrapper && button && menu) {
    // Hover open for mouse/trackpad.
    wrapper.addEventListener('mouseenter', () => setOpen(true));
    wrapper.addEventListener('mouseleave', () => setOpen(false));

    // Keyboard accessibility: open while focusing inside.
    wrapper.addEventListener('focusin', () => setOpen(true));
    wrapper.addEventListener('focusout', (e) => {
      if (!wrapper.contains(e.relatedTarget)) setOpen(false);
    });

    // Touch/mobile fallback: toggle on click.
    button.addEventListener('click', (e) => {
      const isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
      if (!isTouch) {
        // On desktop, hover is the primary interaction.
        e.preventDefault();
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      setOpen(!menu.classList.contains('show'));
    });

    // Prevent clicks inside the menu from bubbling to the document handler.
    menu.addEventListener('click', (e) => e.stopPropagation());
  }

  container.querySelectorAll('[data-lang]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const lang = el.getAttribute('data-lang');
      if (!lang || lang === current) return;

      // Keep existing behavior: update URL ?lang=, persist to localStorage
      setLanguage(lang);

      // Static pages + quote form are rendered once; reload to apply language instantly.
      window.location.reload();
    });
  });
}

export function initLanguageSwitcher() {
  const container = document.getElementById('alictron-language-switcher');
  if (!container) return;

  // Close dropdown when clicking elsewhere / pressing Escape.
  // Installed once globally; safe across pages.
  if (!window.__alictronLangSwitcherGlobal__) {
    window.__alictronLangSwitcherGlobal__ = true;

    document.addEventListener('click', () => {
      document.querySelectorAll('.alictron-lang .dropdown-menu.show').forEach((m) => m.classList.remove('show'));
      document.querySelectorAll('.alictron-lang button[aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.alictron-lang .dropdown-menu.show').forEach((m) => m.classList.remove('show'));
      document.querySelectorAll('.alictron-lang button[aria-expanded="true"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    });
  }

  render(container);

  window.addEventListener('languagechange', () => {
    render(container);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initLanguageSwitcher();
});
